var React = require('react');

function Smartphone (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",{},React.createElement("path",{"d":"M25.302,0H9.698c-1.3,0-2.364,1.063-2.364,2.364v30.271C7.334,33.936,8.398,35,9.698,35h15.604   c1.3,0,2.364-1.062,2.364-2.364V2.364C27.666,1.063,26.602,0,25.302,0z M15.004,1.704h4.992c0.158,0,0.286,0.128,0.286,0.287   c0,0.158-0.128,0.286-0.286,0.286h-4.992c-0.158,0-0.286-0.128-0.286-0.286C14.718,1.832,14.846,1.704,15.004,1.704z M17.5,33.818   c-0.653,0-1.182-0.529-1.182-1.183s0.529-1.182,1.182-1.182s1.182,0.528,1.182,1.182S18.153,33.818,17.5,33.818z M26.021,30.625   H8.979V3.749h17.042V30.625z","style":{}}))));
}

Smartphone.defaultProps = {"version":"1.1","x":"0","y":"0","viewBox":"0 0 35 35","style":{"enableBackground":"new 0 0 512 512"},"xmlSpace":"preserve","className":"","width":"32","height":"32"};

module.exports = Smartphone;

Smartphone.default = Smartphone;
